import creditEngineRepository, { CreditEngineRepository } from "./CreditEngineRepository";

const resource = "/mail";
export default {
  sendMail(sendMailRequest) {
    creditEngineRepository.setContentType("application/json");
    return CreditEngineRepository.post(`${resource}`, sendMailRequest);
  },
};
